import React, { useContext } from 'react'
import { RouterProps } from 'react-router'
import useUser from '../../contexts/hooks/useUser'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'
import PageWrapper from '../../wrappers/pageWrapper/PageWrapper'
import CarStateCard from './components/carStateCard/CarStateCard'
import HvacStateCard from './components/hvacStateCard/HvacStateCard'
import MainView from './components/MainView'
import MeteringTypeCard from './components/MeteringTypeCard'
import Notifications from './components/notifications/NotificationsBell'
import OurProductsCard from './components/OurProductsCard'
import OverviewBackground from './components/OverviewBackground'
import PanelStateCard from './components/panelStateCard/PanelStateCard'
import PriceComparisonCard from './components/PriceComparisonCard'
import PricesCard from './components/PricesCard'
import './Home.scss'

const Home: React.FC<RouterProps> = () => {
	const { streetAddress, price } = useContext(ObjectContext)

	const { user, isCustomer } = useUser()

	return (
		<PageWrapper
			page='overview'
			appBarOptions={{
				label: streetAddress ?? '',
				overrideBackgroundStyle: 'relative bg-transparent text-white',
				rightContent: <Notifications />,
			}}
		>
			<OverviewBackground />
			<div className='flex'>
				<div id='consumption' className='flex flex-col gap-md '>
					<MainView />

					<div className='w-full gap-md grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3'>
						{price.isSpotMargin && <PricesCard />}
						{!isCustomer && <OurProductsCard />}
						<PriceComparisonCard />
						{user?.vehicleLinked ? <CarStateCard /> : null}
						{user?.panelLinked ? <PanelStateCard /> : null}
						{user?.hvacLinked ? <HvacStateCard /> : null}
						<MeteringTypeCard />
					</div>
				</div>
			</div>
		</PageWrapper>
	)
}

export default Home
